import { Components, Theme } from '@mui/material';

const muiSvgIcon: Components<Theme>['MuiSvgIcon'] = {
	defaultProps: {
		// TODO: in some way extract from theme
		color: '##15263E',
	},
};

export default muiSvgIcon;
